import { Quote, ShieldCheck,  TrendingUp, Zap,Lock,Smartphone,Briefcase,Handshake,Search,BarChart3,LayoutDashboard ,MonitorDot} from 'lucide-react';
import kidBg from '../assets/bgcloud.png'; // Using your existing cloud background
import founderImg from "../assets/san.png";
import heroBg from "../assets/about-bg.png";
import aboutTree from "../assets/about-tree.png"
import storyImg from "../assets/about-story.png"
import missionBg from "../assets/mission.png"
import sadayImg from "../assets/saday.png"
import priyankaImg from "../assets/priyanka.png"
import bpImg from "../assets/business-planning-1.png"
import React,{ useRef } from 'react';
import { motion, useScroll, useSpring,useTransform } from 'framer-motion';
import faqBg from '../assets/faq.png';

const AboutUs = () => {
  // 1. Setup Scroll Progress for the central line
const containerRef = useRef(null);

  // Tracks scroll for the line
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start center", "end center"]
  });

  const scaleY = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

type TimelineItem = {
  year: string;
  title: string;
  desc: string;
};

function TimelineCard({
  item,
  isEven,
}: {
  item: TimelineItem;
  isEven: boolean;
}) {
  const cardRef = useRef<HTMLDivElement | null>(null);

  const { scrollYProgress } = useScroll({
    target: cardRef,
    offset: ["start 90%", "end 40%"],
  });

  const x = useTransform(
    scrollYProgress,
    [0, 1],
    isEven ? [-150, 0] : [150, 0]
  );

  const opacity = useTransform(scrollYProgress, [0, 0.4], [0, 1]);

  return (
    <motion.div
      ref={cardRef}
      style={{ x, opacity }}
      className="w-full md:w-[44%] group"
    >
      <div
  className={`relative p-6 md:p-7 rounded-[20px] bg-white border border-slate-100 
  shadow-sm hover:shadow-lg transition-all duration-400 hover:-translate-y-1 
  overflow-hidden ${isEven ? "md:text-right" : "md:text-left"}`}
>

        <h4 className="font-syne text-2xl font-bold text-slate-900 mb-4 group-hover:text-red-600 transition-colors">
          {item.title}
        </h4>
        <p className="text-slate-600 leading-relaxed text-base md:text-md">
          {item.desc}
        </p>
      </div>
    </motion.div>
  );
}



  const timelineData = [
    { year: "2018", title: "The Genesis", desc: "DreamLadder Capital was founded with a single mission: to bring institutional discipline and structured wealth practices to individual families. Expanded into a boutique platform offering Corporate FD, Protection, and regulated PMS/AIF access." },
    { year: "2019", title: "Digital Expansion", desc: "Launched our proprietary digital platform, enabling seamless wealth access for clients across India." },
    { year: "2021", title: "Global Footprint", desc: "Expanded services to NRIs and global families, reaching clients across 10+ countries worldwide." },
    { year: "2023", title: "Wealth Suite", desc: "Evolved into a boutique firm offering Corporate FDs, Protection Solutions, and PMS/AIF structures." },
    { year: "2025", title: "500+ Families", desc: "Proudly managing long-term wealth strategies for over 500+ families across generations." },
  ];
  return (
    <div className="min-h-screen bg-white text-gray-800 font-sans">
      
      {/* 1. Hero / Header Section */}
   
{/* ================= HERO / HEADER ================= */}

<section
  className="relative pt-16 md:pt-28 pb-16 md:pb-24 overflow-hidden pl-52 min-h-screen flex flex-col justify-center " // Added min-h-screen and flex centering
  style={{
    backgroundImage: `url(${heroBg || kidBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>

{/* TOP FADE (Optional, for seamless top) */}
<div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-white to-transparent pointer-events-none z-20" />


{/* BOTTOM MERGE: The "Sweet Spot" height for a professional blend */}
<div className="absolute bottom-0 left-0 w-full h-40 md:h-60 bg-gradient-to-t from-white via-white/50 to-transparent pointer-events-none z-20" />

  <div className="relative max-w-[1440px] mx-auto px-6 sm:px-12 lg:px-24 w-full"> {/* Added w-full */}
<div className="hidden lg:block absolute left-[-15px] top-0 h-full w-[32%] pointer-events-none">
  <div className="absolute bottom-[60px] left-[-138px]">
    <img
      src={aboutTree}
      alt="Growth Tree"
      className="h-[400px] w-auto max-w-none object-contain"
    />
  </div>
</div>

    {/* TREE LANE (ABSOLUTE but CONSTRAINED) 
    <div className="hidden lg:block absolute left-11 top-0 h-full w-[32%] pointer-events-none">
      <div className="absolute bottom-[40px] left-[-120px]">
        <img
          src={aboutTree}
          alt="Growth Tree"
          className="h-[500px] w-auto object-contain"
        />
      </div>
    </div>*/}

    {/* CONTENT LANE className="h-[500px] w-auto object-contain"*/}
    <div className="relative z-10 flex items-center justify-between">

      {/* EMPTY SPACE FOR TREE (STRUCTURAL, NOT VISUAL) */}
      <div className="hidden lg:block w-[39%]" />

      {/* CENTER — QUOTE */}

      <div className="w-[34%] text-center px-6 ml-10">
        {/*
        <h1 className="font-syne text-[14px] md:text-[38px] font-medium text-black leading-tight tracking-tight mb-1 md:mb-3">
          “Wealth is not built overnight; it’s crafted through{" "}
          <span className="text-red-600 italic ">
            clarity, courage, and consistency
          </span>.”
        </h1>
 */}

 
         <h2 className="font-syne text-2xl md:text-3xl font-thin text-black/70 mb-2 md:mb-4 leading-[1.1] whitespace-pre-line tracking-tighter">
  “Wealth is not built overnight; it’s crafted through{" "}
          <span className="text-red-600 italic ">
            clarity, courage, and consistency
          </span>.”
</h2>

        <div className="flex flex-col items-center">
          <span className="w-14 h-[3px] bg-red-600 rounded-full mb-3" />
          <p className="text-[17px] md:text-[20px] font-semibold text-slate-900">
            Mr. Saday Sinha
          </p>
          <p className="text-[11px] md:text-[12px] text-slate-600 font-medium uppercase tracking-[0.35em] mt-1">
            Founder & CEO
          </p>
        </div>
      </div>

      {/* RIGHT — FOUNDER */}
      
      <div className="w-[33%] flex justify-end items-end translate-x-1 xl:translate-x-4">
        <div className="relative">
          <div className="absolute -bottom-10 left-1/2 -translate-x-1/2 w-[70%] h-[60%] bg-red-600/10 blur-[100px] rounded-full" />

          <img
            src={founderImg}
            alt="Mr. Saday Sinha"
            className="h-[420px] md:h-[560px] w-auto object-contain relative z-10"
          />
        </div>
      </div>
    </div>
    
    
    
  </div>
</section>



   {/* 3. Our Story Section */}
{/* 3. Our Story Section */}
<section className="py-10 md:py-16 bg-white -mt-11">
  <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20">

    <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">

      {/* LEFT — TEXT */}
      <div className="order-2 lg:order-1 lg:col-span-2">
        <div className="max-w-[560px] md:max-w-[600px]">
          <h3 className="text-[24px] md:text-[40px] font-[450] text-gray-900 tracking-tight mb-6">
            Our Story
          </h3>

          <div className="space-y-6 text-slate-600 text-[16px] md:text-[18px] leading-relaxed">
            <p>
              Every great journey begins with a simple belief. Ours began in 2018
              with the conviction that investing should be transparent,
              straightforward, and built on trust.
            </p>

            <p>
              What started as a focused effort in Mutual Funds has expanded into a
              comprehensive wealth management suite, including Corporate FDs,
              Protection Solutions, and Structured Products.
            </p>

            <p>
              Today, we serve over 500+ families across 12 countries, achieving
              milestones driven by the same purpose: helping people grow their
              wealth with clarity.
            </p>
          </div>

          <div className="mt-10 grid grid-cols-2 gap-8">
            <div>
              <h4 className="text-4xl font-medium text-red-600">25+</h4>
              <p className="text-slate-500 font-medium uppercase tracking-wider text-sm">
                Years Expertise
              </p>
            </div>
            <div>
              <h4 className="text-4xl font-medium text-red-600">500+</h4>
              <p className="text-slate-500 font-medium uppercase tracking-wider text-sm">
                Families Served
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* RIGHT — IMAGE */}
      <div className="order-1 lg:order-2 lg:col-span-3 flex justify-center lg:justify-end">
        <img
          src={storyImg}
          alt="Family and Wealth Journey"
          className="w-full max-w-[780px] object-contain"
        />
      </div>

    </div>
  </div>
</section>

<section
  className="py-16 md:py-24 relative pl-12"
  style={{
    backgroundImage: `url(${missionBg})`,
    backgroundSize: "cover",
    backgroundPosition: "85% center",
  }}
>
  <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
    
    {/* RIGHT ALIGNED CONTENT WRAPPER */}
    <div className="flex justify-end">
      <div className="max-w-[520px] text-right">

        <div className="flex justify-end mb-6">
          <Quote size={48} className="text-red-600 opacity-50" />
        </div>

        <h2 className="font-syne text-[20px] md:text-[26px] italic font-normal text-slate-800 leading-relaxed">

          “Our mission is to be one of India’s most trusted partners in building
          long-term wealth. Every solution we create is designed to be simple,
          transparent, and effective.”
        </h2>

        <div className="mt-8">
          <p className="font-bold text-slate-900 text-lg">
            Mr. Saday Sinha
          </p>
          <p className="text-red-600 font-medium">
            Founder & CEO, DreamLadder Capital
          </p>
        </div>

      </div>
    </div>

  </div>
</section>

<section 
      ref={containerRef} 
      className="pt-12 pb-24 relative overflow-hidden bg-white"
    >
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-red-50/50 blur-[120px] rounded-full -z-10" />
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-slate-50/50 blur-[120px] rounded-full -z-10" />

      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
        <div className="text-center mb-20">
          <h3 className="text-[24px] md:text-[40px] font-[450] text-gray-900 tracking-tight mb-4">
           Our Journey
          </h3>
          {/*<div className="w-24 h-[3px] bg-gradient-to-r from-red-500 to-red-700 mx-auto rounded-full" /> */}
        </div>

        <div className="relative">
          {/* Static Background Line */}
          <div className="absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-[2px] bg-slate-100 hidden md:block" />
          
          {/* Drawing Red Line */}
          <motion.div 
            style={{ scaleY, transformOrigin: "top" }}
            className="absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-[2px] bg-red-600 hidden md:block z-10"
          />

          <div className="space-y-32">
           {timelineData.map((item, idx) => {
  const isEven = idx % 2 === 0;

  return (
    <div
      key={idx}
      className={`relative flex items-center justify-between flex-col md:flex-row ${
        !isEven ? "md:flex-row-reverse" : ""
      }`}
    >
      {/* Year Node */}
      <div className="absolute left-1/2 -translate-x-1/2 w-20 h-20 bg-white border border-slate-100 shadow-xl rounded-full z-20 hidden md:flex flex-col items-center justify-center">
        <span className="text-red-600 font-bold text-[10px] uppercase tracking-tighter">
          Year
        </span>
        <span className="text-slate-900 font-bold text-lg">
          {item.year}
        </span>
      </div>

      {/* Animated Card */}
      <TimelineCard item={item} isEven={isEven}  />

      {/* Spacer */}
      <div className="hidden md:block w-[44%]" />
    </div>
  );
})}

          </div>
        </div>
      </div>
    </section>

    
{/* ================= 4. CORE VALUES SECTION (THEME PRESERVED) ================= */}
<section  className="relative w-full overflow-hidden pt-16 md:pt-24 pb-30 md:pb-40"
  style={{
    backgroundImage: `url(${kidBg})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center top',
  }}>
  
  <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24 text-center">
    {/* Updated Heading to match the context of the new values */}
    <h3 className="text-[24px] md:text-[40px] font-[450] text-gray-900 tracking-tight mb-12 mt-10">
  Our Core Values
</h3>

    
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
      {[
        { 
          icon: <ShieldCheck size={32} />, 
          title: "Trusted Integrity", 
          desc: "Upholding the highest ethical standards in every financial decision we make for you." 
        },
        { 
          icon: <Search size={32} />, 
          title: "Complete Transparency", 
          desc: "Total clarity in our processes, direct investments, and clear reporting structures." 
        },
        { 
          icon: <Briefcase size={32} />, 
          title: "Professional Experience", 
          desc: "Decades of institutional expertise applied to managing individual and family wealth." 
        },
        { 
          icon: <Handshake size={32} />, 
          title: "Collaborative Relationships", 
          desc: "Partnering with families across generations to ensure a lasting financial legacy." 
        },
      ].map((value, idx) => (
        <div key={idx} className="bg-white/80 backdrop-blur-sm p-8 rounded-3xl shadow-xl shadow-slate-200/50 hover:-translate-y-2 transition-all duration-300 border border-white text-center">
          <div className="w-16 h-16 bg-red-50 text-red-600 rounded-2xl flex items-center justify-center mb-6 mx-auto">
            {value.icon}
          </div>
          <h4 className="font-syne text-xl font-bold text-slate-900 mb-3">{value.title}</h4>
          <p className="text-slate-600 leading-relaxed text-base md:text-md">{value.desc}</p>
        </div>
      ))}
    </div>
  </div>
 
</section>


{/* ================= OUR TEAM SECTION ================= */}
<section className="pb-20 pt-28 bg-white relative overflow-hidden pl-2">
  {/* Elegant vertical accent line */}
  <div className="absolute top-0 right-[15%] w-[1px] h-full bg-slate-100 -z-10" />

  <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24">

      {/* LEFT — INTRO (Original Font Styles) */}
      <div className="lg:col-span-4 lg:sticky lg:top-24 -ml-2">
        <h3 className="text-[24px] md:text-[40px] font-[450] text-gray-900 tracking-tight">
  Our Team
</h3>

        <div className="mt-6 w-12 h-[2px] bg-red-600" />
        <p className="mt-10 text-slate-600 text-lg md:text-xl leading-relaxed">
        A collective of experienced professionals driven by integrity, discipline, and long-term perspective — dedicated to facilitating structured wealth creation and continuity for families.
        </p>
      </div>

      {/* RIGHT — TEAM MEMBERS (Editorial Style) */}
      <div className="lg:col-span-8 space-y-24 ml-10">

        {/* SADAY SINHA — Minimalist Layout */}
        <div className="flex flex-col md:flex-row gap-10 items-center md:items-start">
          <div className="w-full md:w-2/5 shrink-0">
            <div className="relative bg-[#f8f9fa] border border-slate-100 p-4 rounded-lg shadow-sm">
              <img
                src={sadayImg}
                alt="Saday Sinha"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>
          <div className="flex-1">
            <p className="text-red-600 text-[12px] font-bold uppercase tracking-[0.3em] mb-3">
              Founder & CEO
            </p>
           

             <h2 className="font-syne text-[24px] md:text-[32px] font-thin text-black/70 mb-2 md:mb-4 leading-[1.1] whitespace-pre-line tracking-tighter"> Saday Sinha</h2>

            <p className="text-slate-600 leading-relaxed text-base md:text-md">
              Saday Sinha is the Founder and CEO of DreamLadder Capital, a wealth management firm 
              dedicated to helping clients achieve financial independence through tailored investment solutions. 
              His approach is rooted in transparency and goal-oriented growth.
            </p>
          </div>
        </div>

        {/* PRIYANKA MISHRA — Minimalist Layout */}
        <div className="flex flex-col md:flex-row gap-10 items-center md:items-start">
          <div className="w-full md:w-2/5 shrink-0">
            <div className="relative bg-[#f8f9fa] border border-slate-100 p-4 rounded-lg shadow-sm">
              <img
                src={priyankaImg}
                alt="Priyanka Mishra"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>
          <div className="flex-1">
            <p className="text-red-600 text-[12px] font-bold uppercase tracking-[0.3em] mb-3">
              Director
            </p>
           {/*
            <h4 className="font-syne text-[28px] font-bold text-slate-900 mb-6">
              Priyanka Mishra
            </h4>
            */}
              <h2 className="font-syne text-[24px] md:text-[32px] font-thin text-black/70 mb-2 md:mb-4 leading-[1.1] whitespace-pre-line tracking-tighter">  Priyanka Mishra</h2>
            <p className="text-slate-600 leading-relaxed text-base md:text-md">
              Priyanka Mishra serves as a Director at DreamLadder Capital, where she leads 
              Financial Products, Operations, and New Initiatives divisions. She plays a 
              pivotal role in driving innovation and ensuring operational excellence.
            </p>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>

<section className="py-24 bg-white relative overflow-hidden -mt-12">
  {/* Minimalist background accent */}
  <div className="absolute top-0 right-0 w-1/3 h-full bg-slate-50/50 -z-10" />

  {/* Standardized container for equal margins */}
  <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
    
    {/* TOP PART: CONTENT GRID */}
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch mb-16">

      {/* COLUMN 1: TITLE & PHOTO */}
      <div className="flex flex-col">
        <div className="flex-none">
          <h3 className="text-[24px] md:text-[40px] font-[450] text-gray-900 tracking-tight m-0 p-0">
            What helps us do well
          </h3>
          <div className="mt-4 w-12 h-[3px] bg-red-600" />
        </div>
        
        <div className="mt-0 lg:-mt-3 flex-grow">
          <img 
            src={bpImg} 
            alt="Collaboration and Analysis" 
            className="w-full h-full object-cover  max-h-[450px]"
          />
        </div>
      </div>

      {/* COLUMN 2: TILES (Made smaller with p-5 and gap-4) */}
      <div className="flex flex-col justify-start gap-4">
        {[
          {
            icon: <Search className="text-red-600" size={20} />,
            text: "With a senior team of 20+ years in equity research, we provide expert insights and personalized investment strategies tailored for you."
          },
          {
            icon: <Handshake className="text-red-600" size={20} />,
            text: "Trusted, Analysis-Driven: We use advanced financial tools to enhance performance, offering guidance that is simple and focused on your success."
          },
          {
            icon: <TrendingUp className="text-red-600" size={20} />,
            text: "Trust us to deliver the expertise and technology that empowers your financial success."
          }
        ].map((item, idx) => (
          <div 
            key={idx} 
            className="flex items-start gap-5 p-5 bg-white border border-slate-100 rounded-lg shadow-[0_2px_10px_rgba(0,0,0,0.02)]"
          >
            <div className="mt-1 w-10 h-10 shrink-0 bg-red-50 rounded-lg flex items-center justify-center">
              {item.icon}
            </div>
            <p className="text-slate-600 leading-relaxed text-base md:text-md">
              {item.text}
            </p>
          </div>
        ))}
      </div>
    </div>

    {/* BOTTOM PART: SUBSCRIBE BOX */}
  
    
  </div>
</section>


{/*
<section 
  className="relative w-full overflow-hidden -mt-14 pt-24 pb-48 " // Increased bottom padding significantly
  style={{ 
    backgroundImage: `url(${faqBg})`, 
    backgroundSize: 'cover', // Cover is better for responsiveness
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center top' // Keep the top of the image aligned with your negative margin
  }}
>

  <div className="absolute inset-0 bg-white/20 backdrop-blur-[1px] -z-10" />

  <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24 text-center">
    
    <div className="mb-16">
      <h3 className="text-[24px] md:text-[38px] text-slate-900 tracking-tight font-medium leading-tight m-0 p-0">
             Why Us
          </h3>
    </div>

   
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto -mt-6">
      {[
        { title: "Single View Portfolio", desc: "Personal/family’s consolidated investment portfolio at one place to help easy tracking.", icon: <LayoutDashboard size={28} /> },
        { title: "Focus On Analysis", desc: "Sound investment strategies through in-depth market analyses and algorithm-based assessments.", icon: <BarChart3 size={28} /> },
        { title: "Portfolio Monitoring", desc: "Regular review and monitoring of portfolio performance to enable informed decision making.", icon: <MonitorDot size={28} /> },
        { title: "Quick & Convenient", desc: "Digital client onboarding, ease of transactions and faster execution within efficient timelines.", icon: <Zap size={28} /> },
        { title: "Safety & Security", desc: "State-of-the-art bank-grade security with multi-level verification of investments and transactions.", icon: <Lock size={28} /> },
        { title: "Investment Solution At Fingertip", desc: "Access your wealth management tools and investment data anytime, anywhere through our mobile platform.", icon: <Smartphone size={28} /> }
      ].map((item, idx) => (
        <div key={idx} className="group h-[240px] w-full max-w-[320px] mx-auto [perspective:1000px]">
          <div className="relative w-full h-full transition-all duration-1000 [transform-style:preserve-3d] group-hover:[transform:rotateY(-180deg)]">
            
           
            <div className="absolute inset-0 bg-white rounded-xl border border-slate-100 shadow-sm [backface-visibility:hidden] flex flex-col items-center justify-center p-6">
              <div className="w-14 h-14 rounded-full bg-red-600 text-white flex items-center justify-center mb-4 shadow-lg shadow-red-200/50">
                {item.icon}
              </div>
              <h4 className="font-syne text-[18px] font-bold text-slate-900 leading-snug">
                {item.title}
              </h4>
            </div>

       
            <div className="absolute inset-0 h-full w-full bg-[#434242] rounded-xl p-6 text-center [transform:rotateY(-180deg)] [backface-visibility:hidden] flex flex-col items-center justify-center shadow-2xl">
              <h4 className="font-syne text-[15px] font-bold text-white mb-2 uppercase tracking-wider">
                {item.title}
              </h4>
              <p className="text-slate-300 leading-relaxed text-[12.5px]">
                {item.desc}
              </p>
            </div>

          </div>
        </div>
      ))}
    </div>
  </div>
</section>
*/}
<section
  className="relative w-full overflow-hidden -mt-9 pb-20"
  style={{
    backgroundImage: `url(${faqBg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center center",
  }}
>
  <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24 text-center">

    {/* Heading */}
    <div className="mb-12">
     
       <h2 className="font-syne text-[24px] md:text-[32px] font-thin text-black/70 mb-2 md:mb-4 leading-[1.1] whitespace-pre-line tracking-tighter">Why Us</h2>

    </div>

    {/* Cards Grid */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6 max-w-5xl mx-auto">
      {[
        {
          title: "Single View Portfolio",
          desc: "Personal/family’s consolidated investment portfolio at one place to help easy tracking.",
          icon: <LayoutDashboard size={26} />,
        },
        {
          title: "Focus On Analysis",
          desc: "Sound investment strategies through in-depth market analyses and algorithm-based assessments.",
          icon: <BarChart3 size={26} />,
        },
        {
          title: "Portfolio Monitoring",
          desc: "Regular review and monitoring of portfolio performance to enable informed decision making.",
          icon: <MonitorDot size={26} />,
        },
        {
          title: "Quick & Convenient",
          desc: "Digital client onboarding, ease of transactions and faster execution within efficient timelines.",
          icon: <Zap size={26} />,
        },
        {
          title: "Safety & Security",
          desc: "State-of-the-art bank-grade security with multi-level verification of investments and transactions.",
          icon: <Lock size={26} />,
        },
        {
          title: "Investments at Fingertip",
          desc: "Access your wealth management tools and investment data anytime, anywhere through our mobile platform.",
          icon: <Smartphone size={26} />,
        },
      ].map((item, idx) => (
        <div
          key={idx}
          className="group h-[165px] w-full [perspective:1000px]"
        >
          <div className="relative w-full h-full transition-all duration-700 [transform-style:preserve-3d] group-hover:[transform:rotateY(-180deg)]">

            {/* FRONT SIDE */}
            <div className="absolute inset-0 rounded-lg border border-slate-300 shadow-[0_12px_25px_rgba(0,0,0,0.15)] [backface-visibility:hidden] flex flex-col items-center justify-center p-4 transition-shadow duration-300 group-hover:shadow-[0_18px_35px_rgba(0,0,0,0.2)]">
  {/* Reduced icon size from w-14 to w-12 and mb-4 to mb-3 */}
  <div className="w-12 h-12 rounded-full bg-red-600 text-white flex items-center justify-center mb-3 shadow-lg shadow-red-200/40">
    {React.cloneElement(item.icon, { size: 22 })} 
  </div>

  <h4 className="font-syne text-[16px] font-bold text-slate-900 leading-tight text-center px-2">
    {item.title}
  </h4>
</div>

            
            {/* BACK SIDE */}
<div className="absolute inset-0 h-full w-full bg-[#434242] rounded-lg p-4 text-center [transform:rotateY(-180deg)] [backface-visibility:hidden] flex flex-col items-center justify-center shadow-2xl">
  <h4 className="font-syne text-[15px] font-bold text-white mb-2">
    {item.title}
  </h4>
  <p className="text-slate-200 leading-snug text-base md:text-md ">
    {item.desc}
  </p>
</div>

          </div>
        </div>
      ))}
    </div>

  </div>
</section>

    </div>
  );
};

export default AboutUs;


